// i18n area 'common' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.es-ES.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 archivio→«copia de configuración» (#247).
import type { enUS } from './common'

export const esES: typeof enUS = {
  nav: {
    home: 'Home',
    vms: 'Máquinas virtuales',
    templates: 'Templates',
    importVms: 'Importar VMs',
    containers: 'Containers',
    containersApps: 'Apps',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Imágenes OCI',
    containersOciRegistries: 'Registries OCI',
    containersCtTemplates: 'Templates CT',
    networkServices: 'Servicios de red',
    firewall: 'Firewall',
    checkpoints: 'Checkpoints',
    backup: 'Backup',
    monitoring: 'Monitorización',
    cluster: 'Clúster',
    clusterSettings: 'Ajustes globales',
    clusterNodes: 'Nodos',
    clusterDevices: 'Recursos USB y PCIe',
    clusterFederation: 'Federación',
    network: 'Red',
    overlayNetworks: 'Redes overlay',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Datos',
    storages: 'Storage',
    hci: 'Hiperconvergencia',
    ceph: 'Ceph',
    system: 'Sistema',
    tasks: 'Tasks',
    events: 'Eventos',
    audit: 'Auditoría',
    diagnostics: 'Diagnóstico',
    notifications: 'Notificaciones',
    proximity: 'TVirt Proximity',
    users: 'Usuarios y grupos',
    groups: 'Grupos',
    mfa: 'MFA',
    realms: 'Realms y SSO',
    rbac: 'Roles y permisos',
    credentials: 'Credenciales',
    scopes: 'Scopes',
    tags: 'Tags',
    explorer: 'Explorar',
    licensing: 'Licencia',
    information: 'Información'
  },
  mode: {
    light: 'Claro',
    dark: 'Oscuro',
    system: 'Sistema',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Idioma'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Norteamérica',
    southAmerica: 'Sudamérica',
    asia: 'Asia'
  },
  notFound: {
    title: 'Página no encontrada',
    body: 'Esta dirección no corresponde a ninguna página de TVirt — puede haberse movido con una actualización, o el enlace es antiguo.',
    backHome: 'Volver a la Home'
  },
  scopeBrowser: {
    title: 'Scopes',
    all: 'Todo el clúster',
    noChildren: 'Ningún sub-scope aquí',
    recursive: 'Incluir descendientes',
    collapse: 'Contraer el panel de scopes',
    openPicker: 'Explorar los scopes',
    up: 'Subir un nivel',
    countTooltip: '{direct} en este scope · {total} con los descendientes'
  },
  search: {
    tooltip: 'Buscar (⌘K)',
    placeholder: 'Buscar VMs, redes, storage…',
    empty: 'Sin resultados',
    groups: {
      recent: 'Recientes',
      shortcuts: 'Atajos',
      actions: 'Acciones',
      goTo: 'Ir a'
    },
    kind: {
      catalog: 'Catálogo',
      scope: 'Scope',
      node: 'Nodo'
    },
    footer: {
      navigate: 'navegar',
      open: 'abrir',
      close: 'cerrar'
    },
    actions: {
      createVm: 'Crear VM…',
      uploadIso: 'Subir ISO…',
      clusterSettings: 'Ajustes del clúster',
      consoleOf: 'Ir a la consola de {name}'
    }
  },
  stub: {
    containersSummary: 'Aplicaciones y containers de sistema (CT), con sus imágenes OCI, sus registries y sus templates — gestionados junto a las VMs.',
    sectionSummary_vms: 'Máquinas virtuales y sus templates — ciclo de vida, snapshots, migración y consolas.',
    sectionSummary_storages: 'Los storage donde viven discos, imágenes y metadatos de las VMs.',
    sectionSummary_catalogs: 'El hogar de los artefactos de fichero del clúster: imágenes ISO, templates CT y VM y archivos OCI, organizados en catálogos.',
    sectionSummary_overlay: 'Redes overlay VXLAN entre los nodos del clúster.',
    sectionSummary_fabric: 'El inventario de la red física — switches, puertos, LAGGs y redes lógicas.',
    sectionSummary_ipam: 'El direccionamiento derivado de las redes fabric y overlay: quién tiene cada dirección.',
    sectionSummary_services: 'Servidores DHCP y DNS derivados del registro de red.',
    sectionSummary_ceph: 'Clústeres Ceph gestionados en los nodos TVirt.',
    sectionSummary_hci: 'Las tecnologías de storage hiperconvergente en los nodos TVirt.',
    sectionSummary_cluster: 'Nodos, pertenencia y ajustes de clúster.',
    containers: 'Los containers de sistema están en el roadmap — esta sección los alojará.',
    containersApps: 'Las aplicaciones containerizadas están en el roadmap — esta área las alojará.',
    containersPods: 'Los pods agrupan contenedores que comparten red y volúmenes — las instancias son las apps.',
    containersCt: 'Los containers de sistema (CT) están en el roadmap — esta área los alojará.',
    multiscsi: 'TVStor MultiSCSI está en el roadmap — esta área lo alojará.',
    clusterFederation: 'La federación entre clústeres TVirt está en el roadmap — esta área la alojará.',
    containersOciImages: 'Las imágenes OCI están en el roadmap — esta área las alojará.',
    containersOciRegistries: 'Los registries OCI están en el roadmap — esta área los alojará.',
    containersCtTemplates: 'Los templates CT están en el roadmap — esta área los alojará.',
    importVms: 'Los importers ESXi y Proxmox llegarán aquí: conversión de los guests y migración en masa hacia TVirt.',
    backup: 'El backup integrado llega con la 6.2: repositorios content-addressed deduplicados, incrementales CBT, ventanas de inmutabilidad y réplica repo-to-repo.',
    monitoring: 'Los dashboards de contención cluster-wide (cpu.ready, presión PSI, alertas integradas) están en camino — hoy las mismas métricas viven en los detalles de cada VM.'
  },
  home: {
    welcome: 'Ha iniciado sesión con la cuenta: {name}',
    subtitle: 'Aquí tiene su clúster TVirt de un vistazo.',
    loadError: 'No se pudo cargar la vista general — ¿está accesible el backend TVirt?',
    health: {
      ok: 'Todo en orden',
      warning: 'Atención',
      critical: 'Problemas críticos'
    },
    reason: {
      'node-down': '{subject} está apagado',
      'node-stale': '{subject} no da señales desde hace un rato',
      'node-maintenance': '{subject} en mantenimiento',
      'tasks-failed': {
        one: '{n} task fallido en las últimas 24h',
        many: '{n} tasks fallidos en las últimas 24h',
        other: '{n} tasks fallidos en las últimas 24h'
      },
      'storage-degraded': 'storage {subject} degradado',
      'storage-error': 'storage {subject} en error',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store del clúster inalcanzable',
      'license-absent': 'sin licencia — las nuevas VMs no pueden arrancar',
      'license-expired': 'licencia caducada — las nuevas VMs no pueden arrancar',
      'license-exceeded': 'límite de licencia superado — las nuevas VMs no pueden arrancar',
      'failover-reserve-eroded': 'reserva de failover casi consumida',
      'failover-reserve-exhausted': 'reserva de failover agotada — las nuevas VMs no pueden arrancar',

      'oci-cache-nearly-full': 'caché OCI casi llena en {subject} — los digest se desalojan a mano',
      'oci-cache-full': 'caché OCI llena en {subject} — ningún pull funcionará hasta desalojar digest',
      'config-replica-empty': 'réplica de configuración VACÍA en {subject} — el nodo no tiene configuración del clúster hasta que una replicación tenga éxito',
      'config-replica-stalled': 'replicación de configuración parada en {subject} — la copia local va por detrás de la configuración del clúster'
    },
    staleChip: 'Datos no actualizados',
    staleAsOf: 'última réplica {time}',
    zone: {
      nodes: 'Nodos',
      failoverReserve: 'Reserva de failover',
      capacity: 'Capacidad',
      workload: 'Carga de trabajo',
      protection: 'Protección',
      activity: 'Actividad reciente'
    },
    reserve: {
      state: {
        ok: 'Reserva íntegra',
        eroded: 'Reserva casi consumida',
        exhausted: 'Reserva agotada',
        unknown: 'Reserva desconocida'
      },
      tolerate: {
        one: 'tolera la pérdida de {n} nodo',
        many: 'tolera la pérdida de {n} nodos',
        other: 'tolera la pérdida de {n} nodos'
      },
      usedOf: '{used} / {allowed} GiB en uso',
      keepFree: '{n} GiB mantenidos libres para el failover',
      expendable: 'de los cuales {n} sacrificables en servicio',
      headroom: 'aún se pueden arrancar {n} GiB',
      short: 'a la reserva le faltan {n} GiB — las nuevas VMs no pueden arrancar',
      hp: {
        usedOf: 'Páginas de {size} — en uso: {used} / {allowed}',
        keepFree: 'mantenidas libres para el failover: {keep}',
        headroom: 'aún arrancables: {n}',
        short: 'faltan a la reserva: {n} — las nuevas VMs con páginas enormes no pueden arrancar'
      },
      worstCase: 'peor caso: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Ningún nodo ha declarado aún su memoria — la reserva no se puede calcular y ningún arranque se rechaza.',
      reason: {
        attestedDown: 'atestado apagado',
        maintenance: 'en mantenimiento',
        unreachable: 'inalcanzable',
        capacityUnknown: 'memoria no declarada'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} cores / {threads} threads',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} VM activa',
        many: '{n} VMs activas',
        other: '{n} VMs activas'
      },
      activeVmsUnknown: 'VMs activas desconocidas',
      lastSeen: 'visto {time}',
      neverSeen: 'nunca visto',
      down: 'Apagado',
      maintenance: 'Mantenimiento',
      stale: 'Inalcanzable'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisionados',
      reserve: 'reserva {n} GiB',
      unobserved: 'capacidad aún no observada',
      empty: 'Aún sin storage'
    },
    workload: {
      vms: 'Máquinas virtuales',
      apps: 'Apps',
      services: 'Servicios de red',
      empty: 'Aún ninguno',
      phasesUnknown: 'desglose por fase no disponible'
    },
    protection: {
      none: 'Ningún destino de backup configurado — proteja su configuración.',
      configure: 'Configurar los checkpoints',
      noRuns: 'Aún no se ha creado ningún checkpoint.',
      last: 'Último checkpoint',
      onTarget: 'en {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Sin actividad reciente',
      failed24: {
        one: '{n} fallido en 24h',
        many: '{n} fallidos en 24h',
        other: '{n} fallidos en 24h'
      },
      viewAll: 'Ver todos los tasks'
    }
  },
  notes: {
    title: 'Notas',
    tabEdit: 'Editar',
    tabPreview: 'Vista previa',
    placeholder: 'Notas libres del operador — el Markdown se renderiza en la vista previa',
    empty: 'Sin notas',
    tooLarge: 'Las notas superan el límite de 64 KiB',
    saveError: 'No se pudieron guardar las notas'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'La respuesta del backend contiene un valor que esta interfaz no conoce: {field}={value} — actualiza la interfaz web a la versión del backend.',
    contractErrorItems: '{count} objetos de esta lista no son legibles por esta interfaz ({field}={value}) y no se muestran.',
    staleHint: 'El store no está accesible — esta es la réplica de config de este nodo; el estado de la flota es desconocido.',
    staleStateAge: 'estado a {time}',
    staleStateNever: 'estado nunca recibido del store: solo ves las observaciones de este nodo',
    staleStateTooltip: 'El store del clúster no está accesible: el estado observado (fase, nodo, agente) viene de la réplica de estado de este nodo y se remonta a la última lectura correcta del store — puede estar obsoleto.',
    noPermission: 'No tiene permiso para esta acción',
    actionStillRunning: 'La acción sigue en curso: el resultado aún no se conoce',
    staleWrite: 'Otra persona ha modificado este objeto mientras lo editabas — no se ha escrito nada. Recarga y repite el cambio sobre el estado actualizado.',
    staleReload: 'Recargar',
    preview: 'Vista previa',
    previewTitle: 'Vista previa del resultado',
    previewNothingWritten: 'Simulada en el servidor — no se ha escrito nada.',
    previewChanged: 'Resaltados: los valores que cambiarían.'
  },
  context: {
    copySelection: 'Copiar el texto seleccionado'
  },
  crud: {
    create: 'Crear',
    viewDetails: 'Ver detalles',
    viewOrEdit: 'Ver o editar',
    selected: 'seleccionados',
    viewUsingVms: 'Ver las VMs que usan el recurso',
    clearSelection: 'Deseleccionar',
    deleteSelected: 'Eliminar seleccionados',
    bulkConfirmBody: {
      one: '¿Eliminar {count} elemento seleccionado? Si está protegido, se señalará y se mantendrá.',
      many: '¿Eliminar los {count} elementos seleccionados? Los protegidos se señalarán y se mantendrán.',
      other: '¿Eliminar los {count} elementos seleccionados? Los protegidos se señalarán y se mantendrán.'
    },
    bulkDeleted: 'eliminados',
    bulkRefused: 'rechazados',
    fieldId: 'ID',
    createdAt: 'Creado el',
    updatedAt: 'Actualizado el',
    immutableField: 'Fijado en la creación — el contract no permite modificarlo',
    immutableScope: 'El scope se asigna en la creación; algunos recursos se mueven con una acción dedicada',
    observedField: 'Estado observado — reportado por la plataforma, no editable'
  }
}
